import { dbService, resetMasterDataDb } from './db';
import { userService } from './userService';
import Moment from "moment";

export const syncService = {
    syncShipments, syncMasterData, syncCustomerData, resetSyncDate, syncActivityActions, syncProspectActions, syncCustomerNoteActions, resetMasterDataDb
};

async function syncShipments(token) {
    await dbService.resetShipmentDb();
    let db = await dbService.createDB();
    let filterDate = Moment().subtract(10, 'day');
    console.log("syncing up shipments");
    let res ={}
    let shipmentActions = await db.getAllFromIndex("shipmentAction", "syncedIndex", "false");
    if (shipmentActions.length > 0) {
        console.log(`${shipmentActions.length} shipments to sync.`)
        res = await fetch(`/api/shipments`, {
            headers: {
                'Token': token,
                'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify({ data: shipmentActions })
        });

        shipmentActions.forEach(async (shipmentAction) => {
            shipmentAction.synced = "true";
            db.put("shipmentAction", shipmentAction);
        });

    }

    let oldShipmentActions = await db.getAllFromIndex("shipmentAction", "syncedIndex", "true");
            
    oldShipmentActions.filter((it) => { return Moment(it.shipmentDate, 'YYYY-MM-DD').isBefore(filterDate)}).forEach((action) => {
        db.delete("shipmentAction", action.id)
    })

    console.log("populating shipments");
    res = await fetch(`/api/shipments`, {
        headers: {
            'Token': token
        }
    });

    res.json().then(async (shipments) => {
        shipments.forEach(async (shipment) => {
            await db.put("shipments", shipment);
        });
    })
    console.log("shipment population complete");

}

async function syncMasterData(token) {
    await dbService.resetMasterDataDb();
    let db = await dbService.createDB();

    console.log("populating masterdata")
    console.log("populating users")
    let res = await fetch(`/api/users`, {
        headers: {
            'Token': token
        }
    });

    res.json().then(async (users) => {
        users.forEach(async (user) => {
            await db.put("users", user);
        });
    })

    console.log("populating items")
    res = await fetch(`/api/items`, {
        headers: {
            'Token': token
        }
    });

    res.json().then(async (item) => {
        item.forEach(async (item) => {
            await db.put("items", item);
        });
    })

    console.log("masterdata population complete")
}

async function resetSyncDate() {
    const db = await dbService.createDB();
    const now = new Date();
    const twentyFourHoursAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    let session = await userService.getSession();
    session.customerSyncDate = twentyFourHoursAgo;
    db.put("session", session);
}

async function syncProspectActions(activeAccount) {
    const db = await dbService.createDB();
    let prospectActions = await db.getAll("prospectAction");
    if (prospectActions.length > 0) {
        console.log(`${prospectActions.length} prospects to sync.`)
        let res = await fetch(`/api/prospects`, {
            headers: {
                'Token': activeAccount.idToken,
                'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify({ data: prospectActions })
        });
        await db.clear("prospectAction");
    }
}

async function syncCustomerNoteActions(activeAccount) {
    const db = await dbService.createDB();
    let noteActions = await db.getAll("customerNoteAction");
    if (noteActions.length > 0) {
        console.log(`${noteActions.length} notes to sync.`)
        let res = await fetch(`/api/customers/notes`, {
            headers: {
                'Token': activeAccount.idToken,
                'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify({ data: noteActions })
        });
        await db.clear("customerNoteAction");
    }
}


async function syncActivityActions(activeAccount) {
    const db = await dbService.createDB();
    let activityActions = await db.getAll("activityAction");
    if (activityActions.length > 0) {
        console.log(`${activityActions.length} activities to sync.`)
        let res = await fetch(`/api/activities`, {
            headers: {
                'Token': activeAccount.idToken,
                'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify({ data: activityActions })
        });
        await db.clear("activityAction");
    }
}

async function syncCustomerData(activeAccount) {
  await syncActivityActions(activeAccount)
  await dbService.resetCustomerDataDb();
  let token = activeAccount.idToken;
  const db = await dbService.createDB();
  const headers = { 'Token': token };

  console.log("Fetching all data in parallel...");

  const [
    customersRes,
    salesHistoryRes,
    contactsRes,
    activitiesRes,
    itemGroupsRes,
    prospectsRes,
    activityTypesRes,
    salesPricesRes
  ] = await Promise.all([
    fetch(`/api/customers?email=${activeAccount.username}`, { headers }),
    fetch(`/api/sales_history?email=${activeAccount.username}`, { headers }),
    fetch(`/api/customer_contacts?email=${activeAccount.username}`, { headers }),
    fetch(`/api/activities?email=${activeAccount.username}`, { headers }),
    fetch(`/api/item_groups`, { headers }),
    fetch(`/api/prospects?email=${activeAccount.username}`, { headers }),
    fetch(`/api/activity_types`, { headers }),
    fetch(`/api/sales_prices?email=${activeAccount.username}`, { headers }),
  ]);

  const [
    customers,
    salesHistory,
    customerContacts,
    activities,
    itemGroups,
    prospects,
    activity_types,
    salesPrices
  ] = await Promise.all([
    customersRes.json(),
    salesHistoryRes.json(),
    contactsRes.json(),
    activitiesRes.json(),
    itemGroupsRes.json(),
    prospectsRes.json(),
    activityTypesRes.json(),
    salesPricesRes.json()
  ]);

  console.log("Inserting data into IndexedDB in batches...");

  await Promise.all([
    batchInsert(db, "customers", customers),
    batchInsert(db, "salesHistory", salesHistory),
    batchInsert(db, "customerContacts", customerContacts.data),
    batchInsert(db, "activities", activities),
    batchInsert(db, "itemGroups", itemGroups.map((g) => ({ name: g }))),
    batchInsert(db, "prospects", prospects),
    batchInsert(db, "activityTypes", activity_types),
    batchInsert(db, "salesPrices", salesPrices)
  ]);


  let session = await userService.getSession();
  session.customerSyncDate = new Date();
  db.put("session", session);

  console.log("Customer population complete.");
}

//Helper function: insert records in batches of N
async function batchInsert(db, storeName, records, batchSize = 100) {
  for (let i = 0; i < records.length; i += batchSize) {
    const batch = records.slice(i, i + batchSize);
    await Promise.all(batch.map(record => db.put(storeName, record)));
  }
}